import React from 'react';
import { bool, shape, string } from 'prop-types';

const Trap = ({
  className = 'icon',
  notUseClass = false,
  style = { color: 'currentColor' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 1L20 9.68421L12 23L4 9.68421L12 1ZM12 3.88027L6.42182 9.93553L12 19.2203L17.5782 9.93553L12 3.88027Z" fill="currentColor" />
  </svg>
);

Trap.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Trap;
